export const COLORS = [
  '#3B82F6','#10B981','#8B5CF6','#F59E0B','#EF4444','#EC4899',
  '#06B6D4','#F97316','#14B8A6','#6366F1','#84CC16','#D946EF'
];

export const STATUS_COLORS = {
  NEW_LEAD: '#3B82F6',
  CONNECTED: '#10B981',
  INTERESTED: '#8B5CF6',
  FOLLOW_UP_REQUIRED: '#F59E0B',
  APPLICATION_SUBMITTED: '#06B6D4',
  REGISTRATION_COMPLETED: '#14B8A6',
  PAYMENT_PENDING: '#F97316',
  ADMISSION_CONFIRMED: '#22C55E',
  ADMISSION_COMPLETED: '#059669',
  JOINED_BATCH: '#16A34A',
  LOST_LEAD: '#EF4444',
};

export const STATUS_NAMES = {
  NEW_LEAD: 'New Lead',
  CONNECTED: 'Connected',
  INTERESTED: 'Interested',
  FOLLOW_UP_REQUIRED: 'Follow-up Required',
  APPLICATION_SUBMITTED: 'Application Submitted',
  REGISTRATION_COMPLETED: 'Registration Completed',
  PAYMENT_PENDING: 'Payment Pending',
  ADMISSION_CONFIRMED: 'Admission Confirmed',
  ADMISSION_COMPLETED: 'Admission Completed',
  JOINED_BATCH: 'Joined Batch',
  LOST_LEAD: 'Lost Lead',
};

export const PRIORITIES = {
  low: '#6B7280',
  medium: '#3B82F6',
  high: '#F59E0B',
  urgent: '#EF4444',
};

export const MONTH_ABBR = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export const SYNC_LOG_STATUS_COLORS = {
  processed: '#10B981',
  duplicate: '#6B7280',
  unmapped: '#F59E0B',
  failed: '#EF4444',
};

export const DUPLICATE_RULES = [
  { value: 'mobile', label: 'Check Mobile Number' },
  { value: 'email', label: 'Check Email' },
  { value: 'both', label: 'Check Both' },
];

export const ROW_STATUS = {
  valid: { label: 'Valid', color: '#10B981' },
  error: { label: 'Error', color: '#EF4444' },
  duplicate: { label: 'Duplicate', color: '#F59E0B' },
  unchecked: { label: 'Unchecked', color: '#6B7280' },
};

export const ACTION_COLS = ['create','read','update','delete','export','import','assign','approve'];

export const MENU_CODE_ALIASES = { 'csv-import': 'csv', 'audit-logs': 'audit' };
